import { motion } from 'framer-motion';
import { Users, Brain, Briefcase, GraduationCap } from 'lucide-react';

const audiences = [
  {
    icon: Brain,
    title: 'Life Coaches',
    description: 'Use this tool to uncover unconscious patterns in your clients and create impactful coaching plans.'
  },
  {
    icon: Users,
    title: 'Personal Development Seekers',
    description: 'Gain clarity on your strengths and areas for growth.'
  },
  {
    icon: Briefcase,
    title: 'HR Professionals',
    description: 'Identify and nurture talent within your teams.'
  },
  {
    icon: GraduationCap,
    title: 'Educators and Trainers',
    description: 'Empower your students or participants to unlock their potential.'
  }
];

export function AudienceSection() {
  return (
    <section id="audience" className="py-20 px-4">
      <div className="w-full">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16 w-full"
        >
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Who Is It For?
          </h2>
          <p className="text-gray-600 text-lg w-full">
            Designed for professionals and individuals committed to growth and transformation
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 w-full">
          {audiences.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-white rounded-3xl shadow-sm border border-gray-200 hover:shadow-md transition-all duration-300 hover:scale-[1.02]"
            >
              <div className={`p-8 text-center h-full min-h-[320px] flex flex-col justify-center ${
                index === 0 ? 'bg-blue-50 border-blue-100' :
                index === 1 ? 'bg-emerald-50 border-emerald-100' :
                index === 2 ? 'bg-purple-50 border-purple-100' :
                'bg-amber-50 border-amber-100'
              } rounded-3xl`}>
                <div className={`inline-flex items-center justify-center w-20 h-20 rounded-full mb-6 mx-auto ${
                  index === 0 ? 'bg-blue-100' :
                  index === 1 ? 'bg-emerald-100' :
                  index === 2 ? 'bg-purple-100' :
                  'bg-amber-100'
                }`}>
                  <item.icon className={`w-10 h-10 ${
                    index === 0 ? 'text-blue-600' :
                    index === 1 ? 'text-emerald-600' :
                    index === 2 ? 'text-purple-600' :
                    'text-amber-600'
                  }`} />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {item.title}
                </h3>
                <p className="text-lg text-gray-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}